import { emptyMerchantMapping, merchantFieldKeys, type MerchantFieldKey, type MerchantMapping } from '../domain/merchant.js'

const aliases: Record<MerchantFieldKey, string[]> = {
  id: ['id', 'product id', 'product_id', 'sku', 'identifier'],
  title: ['title', 'product title', 'product_title', 'name', 'product name'],
  description: ['description', 'product description', 'product_description', 'short description'],
  link: ['link', 'product link', 'product_link', 'url', 'product url', 'permalink'],
  imageLink: ['image link', 'image_link', 'image url', 'image_url', 'images', 'image'],
  availability: ['availability', 'stock status', 'stock_status', 'in stock?', 'in_stock'],
  price: ['price', 'regular price', 'regular_price', 'sale price'],
  brand: ['brand', 'manufacturer'],
  gtin: ['gtin', 'ean', 'upc', 'barcode'],
  mpn: ['mpn', 'manufacturer part number', 'manufacturer_part_number'],
  condition: ['condition', 'product condition'],
  identifierExists: ['identifier exists', 'identifier_exists'],
  itemGroupId: ['item group id', 'item_group_id', 'parent sku', 'parent_sku'],
}

const normalize = (value: string) => value
  .trim()
  .toLocaleLowerCase()
  .replace(/^g:/, '')
  .replace(/[\[\]]/g, '')
  .replace(/[-]+/g, '_')
  .replace(/\s+/g, ' ')

export function detectMerchantMapping(headers: string[]): MerchantMapping {
  const mapping = emptyMerchantMapping()
  const normalizedHeaders = headers.map((header) => ({ header, normalized: normalize(header) }))

  for (const field of merchantFieldKeys) {
    const normalizedAliases = aliases[field].map(normalize)
    mapping[field] = normalizedHeaders.find(({ normalized }) => normalizedAliases.includes(normalized))?.header ?? ''
  }

  return mapping
}
